export var NON_SOCIAL_PLAN_TYPES = {
  COMMERCIAL: 'commercial',
  MEDICARE: 'medicare',
  MEDICAID: 'medicaid',
  UNKNOWN: 'unknown',
  TRICARE: 'tricare'
};
export var FAILED_ARCHIVE_MESSAGE = 'Insurance Entry Not Deleted.';
export var SUCCESSFUL_ARCHIVE_MESSAGE = 'Insurance Entry Successfully Deleted.';
export var FAILED_CREATE_MESSAGE = 'Insurance Information Not Added.';
export var SUCCESSFUL_CREATE_MESSAGE = 'Insurance Information Successfully Added.';
export var FAILED_UPDATE_MESSAGE = 'Insurance Information Not Updated.';
export var SUCCESSFUL_UPDATE_MESSAGE = 'Insurance Information Successfully Updated.';
export var DISALLOWED_ARCHIVE_SCC_STATUSES = ['pending_disenrollment', 'pending_enrollment', 'enrolled'];
//# sourceMappingURL=constants.js.map